import {PayloadAction} from '@reduxjs/toolkit';
import {AxiosError} from 'axios';
import {showNotification} from 'platform/components';
import {all, put, takeEvery, takeLeading, call} from 'typed-redux-saga';

import {RoleService} from '../../services/RoleService';
import {DeleteRoleType} from '../../types/UserManagementTypes';
import {callApiSaga} from '../../utils/api';
import {getStatusCode, isAxiosError} from '../../utils/customError';
import {getErrorMessages} from '../../utils/getErrorMessage';
import {getStringErrorMessage} from '../../utils/getStringErrorMessage';
import {
  deleteRoleRequest,
  deleteRoleSuccess,
  fetchFullRoleError,
  fetchFullRoleRequest,
  fetchFullRoleSuccess,
  fetchRoleError,
  fetchRoleRequest,
  fetchRoleSuccess,
} from './reducer';

function* handlingError(error: AxiosError | Error, addInfo?: string): Generator {
  const axiosError = isAxiosError(error);
  const title = axiosError ? String(getStatusCode(error)) : error;
  const subtitle = addInfo ? addInfo : axiosError ? getErrorMessages(error) : error;

  showNotification.error(`${title}: ${subtitle}`);
}

function* fetchRoleList(): Generator {
  // TODO params with [BE]
  try {
    const response = yield* callApiSaga(RoleService.getRolesForRoleManagement, {});
    yield* put(fetchRoleSuccess(response));
  } catch (error: any) {
    yield* put(fetchRoleError(error));
    yield* call(handlingError, error as AxiosError);
  }
}

function* fetchAllACLRoles(): Generator {
  // TODO params with [BE]
  try {
    const response = yield* callApiSaga(RoleService.getRoles, {});
    yield* put(fetchFullRoleSuccess(response));
  } catch (error: any) {
    yield* put(fetchFullRoleError(error));
    yield* call(handlingError, error as AxiosError);
  }
}

function* deleteSingleRoleById({
  payload: {roleId, successMessage},
}: PayloadAction<DeleteRoleType>): Generator {
  try {
    yield* callApiSaga(RoleService.deleteRole, {roleId: roleId ?? ''});
    yield* put(deleteRoleSuccess({roleId}));
    showNotification.success(successMessage);
  } catch (error: any) {
    showNotification.error(getStringErrorMessage(error));
  }
}

export function* userManagementSaga(): Generator {
  yield* all([
    takeLeading(fetchRoleRequest, fetchRoleList),
    takeLeading(fetchFullRoleRequest, fetchAllACLRoles),
    takeEvery(deleteRoleRequest, deleteSingleRoleById),
  ]);
}
